import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyStepperTranslations = wrapTranslationsSchema({
	name: 'BuyEasyStepperTranslations',
	title: 'Stepper Translations',
	sanityId: 'buyeasy-wizardStepper',
	fields: {
		progress: 'Step {current} of {total}',
		purchaseValueLabel: 'Purchase Value',
		categoryLabel: 'Category',
		applicabilityLabel: 'Applicability',
		resultsLabel: 'Results',
	},
});
